import { useState, useEffect, useCallback } from 'react';
import { getCurrentPosition } from '../utils/location';

export const useGeoLocation = () => {
  const [locationData, setLocationData] = useState({ latitude: null, longitude: null, address: null });
  const [isLocationLoading, setIsLocationLoading] = useState(true);
  const [locationFetched, setLocationFetched] = useState(false);
  const [permissionDenied, setPermissionDenied] = useState(false);
  const [positionUnavailable, setPositionUnavailable] = useState(false);

  const fetchLocation = useCallback(() => {
    setIsLocationLoading(true);
    setPermissionDenied(false);
    setPositionUnavailable(false);
    
    return getCurrentPosition()
      .then(location => {
        if (location) {
          setLocationData(location);
        }
        setLocationFetched(true);
        return location;
      })
      .catch((error) => {
        if (error) {
          if (error.code === 'PERMISSION_DENIED') {
            setPermissionDenied(true);
          } else if (error.code === 'POSITION_UNAVAILABLE') {
            setPositionUnavailable(true);
          }
          throw error;
        }
        setLocationFetched(true);
      })
      .finally(() => {
        setIsLocationLoading(false);
      });
  }, []);

  useEffect(() => {
    fetchLocation();
  }, [fetchLocation]);

  return { 
    locationData, 
    isLocationLoading, 
    locationFetched,
    permissionDenied,
    positionUnavailable,
    refreshLocation: fetchLocation
  };
};